/**
 * Helpers de typage des documents joueurs (image / pdf / vidéo / html)
 * Partagés entre CreateDocuments, DocumentsTab et AllDocumentsTable.
 */

export const isImage = (ft) => !!ft && ft.startsWith('image/');
export const isPdf = (ft) => ft === 'application/pdf';
export const isVideo = (ft) => !!ft && (ft.startsWith('video/') || ft === 'video/quicktime');
export const isHtml = (ft) => ft === 'text/html';

// Limites de taille par type (octets) — alignées sur le backend
export const MAX_SIZE_DEFAULT = 10 * 1024 * 1024; // images, pdf, html
export const MAX_SIZE_VIDEO = 20 * 1024 * 1024; // vidéo (.mov, .mp4)

// Types MIME acceptés à l'upload
export const VALID_TYPES = [
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'application/pdf', 'image/heic', 'image/heif',
  'video/quicktime', 'video/mp4', 'text/html',
];

// Extensions acceptées en repli quand le navigateur n'envoie pas de mimetype fiable
export const VALID_EXTS = ['.heic', '.heif', '.mov', '.mp4', '.html', '.htm'];

/**
 * Indique si un fichier (type MIME ou extension) est une vidéo.
 * @param {string} fileTypeOrExt - ex: 'video/quicktime' ou '.mov' ou 'mov'
 */
export const isVideoLike = (fileTypeOrExt = '') => {
  const v = String(fileTypeOrExt).toLowerCase();
  return v.startsWith('video/') || v === '.mov' || v === 'mov' || v === '.mp4' || v === 'mp4';
};

/**
 * Retourne la taille max autorisée pour un type/extension donné.
 */
export const maxSizeForType = (fileTypeOrExt = '') =>
  isVideoLike(fileTypeOrExt) ? MAX_SIZE_VIDEO : MAX_SIZE_DEFAULT;

/**
 * Valide un objet File côté navigateur (type + extension).
 * @returns {boolean}
 */
export const isAcceptedFile = (file) => {
  if (!file) return false;
  const ext = '.' + (file.name.split('.').pop() || '').toLowerCase();
  return VALID_TYPES.includes(file.type) || VALID_EXTS.includes(ext);
};
